import React from 'react';
import SearchBox from '../../../../components/outline/SearchBox';
import BaseForm from '../../../../components/form/BaseForm';
import TextArea from '../../../../components/input/TextArea/TextArea';
import { setIfNull, setTrim } from '../../../../lib/common';
import DateRangePicker from '../../../../components/datePicker/DateRangePicker';
import { _LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';
import {
  POINT_REFERRAL_ISSUE_LIST_SEARCH_DATA_MODEL,
  POINT_REFERRAL_ISSUE_LIST_SEARCH_OPTION_MODEL,
} from '../../../../store/modules/point/models';
import {
  MAXIMUM_NUMBER_OF_SEARCH_BOX_REFERRAL_CODE,
  MAXIMUM_NUMBER_OF_SEARCH_BOX_USER_ID,
} from '../../../../constants/service/app/pointConstants';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';
import './PointReferralIssueListSearchBox.scss';

const PointReferralIssueListSearchBox = (props) => {
  const { setData, searchData, getList } = props;
  const { referralUserId, referralIssueDate, referralCode } = searchData;

  return (
    <SearchBox
      className="point-referral-issue-list-search-box"
      onSearch={() => {
        getList({
          searchOption: searchData,
          pagination: _LIST_PAGINATION_MODEL,
        });
      }}
      onClear={() => {
        getList({
          searchOption: POINT_REFERRAL_ISSUE_LIST_SEARCH_OPTION_MODEL,
          pagination: _LIST_PAGINATION_MODEL,
        });
        setData({
          path: [],
          value: POINT_REFERRAL_ISSUE_LIST_SEARCH_DATA_MODEL,
        });
      }}
    >
      {/*userId 로 검색 input*/}
      <BaseForm
        label="유저 ID"
        content={
          <div className="input-search-wrap">
            <TextArea
              value={referralUserId}
              maxLength={MAXIMUM_NUMBER_OF_SEARCH_BOX_USER_ID}
              onChange={(value) => {
                setData({
                  path: ['referralUserId'],
                  value: setIfNull(setTrim(value)),
                });
              }}
              onPressEnter={() =>
                getList({
                  searchOption: searchData,
                  pagination: _LIST_PAGINATION_MODEL,
                })
              }
            />
          </div>
        }
      />

      <BaseForm
        label="친구 추천 코드"
        content={
          <div className="input-search-wrap">
            <TextArea
              value={referralCode}
              maxLength={MAXIMUM_NUMBER_OF_SEARCH_BOX_REFERRAL_CODE}
              onChange={(value) => {
                setData({
                  path: ['referralCode'],
                  value: setIfNull(setTrim(value)),
                });
              }}
              onPressEnter={() =>
                getList({
                  searchOption: searchData,
                  pagination: _LIST_PAGINATION_MODEL,
                })
              }
            />
          </div>
        }
      />

      <BaseForm
        label="레퍼럴 발급 받은 날짜"
        content={
          <div className="quick-date-picker">
            <DateRangePicker
              value={referralIssueDate}
              format={DATE_FORMAT.YMD_DASH_FORMAT}
              outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
              onSelect={(value) =>
                setData({
                  path: ['referralIssueDate'],
                  value,
                })
              }
            />
          </div>
        }
      />
    </SearchBox>
  );
};

export default PointReferralIssueListSearchBox;
